module.exports = __webpack_public_path__ + "img/dbbg.83360c37.png";